import { render, staticRenderFns } from "./NotificationCompose.vue?vue&type=template&id=25676492&scoped=true&"
import script from "./NotificationCompose.vue?vue&type=script&lang=js&"
export * from "./NotificationCompose.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCompose.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationCompose.vue?vue&type=style&index=1&id=25676492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25676492",
  null
  
)

export default component.exports